import common from '@/localization/modules/common';

import accessCode from '@/localization/modules/accessCode';
import account from '@/localization/modules/account';
import announcement from '@/localization/modules/announcement';
import home from '@/localization/modules/home';
import login from '@/localization/modules/login';
import meters from '@/localization/modules/meters';
import mobileApp from '@/localization/modules/mobileApp';
import newRequest from '@/localization/modules/newRequest';
import news from '@/localization/modules/news';
import notFound from '@/localization/modules/notFound';
import oss from '@/localization/modules/oss';
import ossInfo from '@/localization/modules/ossInfo';
import ossResult from '@/localization/modules/ossResult';
import ossVote from '@/localization/modules/ossVote';
import payment from '@/localization/modules/payment';
import personalAccounts from '@/localization/modules/personalAccounts';
import polls from '@/localization/modules/polls';
import privilegeClub from '@/localization/modules/privilegeClub';
import profile from '@/localization/modules/profile';
import register from '@/localization/modules/register';
import requestConfirmation from '@/localization/modules/requestConfirmation';
import requests from '@/localization/modules/requests';
import services from '@/localization/modules/services';
import shop from '@/localization/modules/shop';
import support from '@/localization/modules/support';
import userCart from '@/localization/modules/userCart';
import accessGuide from '@/localization/modules/accessGuide';
import feedback from '@/localization/modules/feedback';
import paymentInvoice from '@/localization/modules/paymentInvoice';

export default {
  ru: {
    ...common.ru,
    ...accessCode.ru,
    ...account.ru,
    ...announcement.ru,
    ...home.ru,
    ...login.ru,
    ...meters.ru,
    ...mobileApp.ru,
    ...newRequest.ru,
    ...news.ru,
    ...notFound.ru,
    ...oss.ru,
    ...ossInfo.ru,
    ...ossResult.ru,
    ...ossVote.ru,
    ...payment.ru,
    ...personalAccounts.ru,
    ...polls.ru,
    ...privilegeClub.ru,
    ...profile.ru,
    ...register.ru,
    ...requestConfirmation.ru,
    ...requests.ru,
    ...services.ru,
    ...shop.ru,
    ...support.ru,
    ...userCart.ru,
    ...accessGuide.ru,
    ...feedback.ru,
    ...paymentInvoice.ru,
  },

  en: {
    ...common.en,
    ...accessCode.en,
    ...account.en,
    ...announcement.en,
    ...home.en,
    ...login.en,
    ...meters.en,
    ...mobileApp.en,
    ...newRequest.en,
    ...news.en,
    ...notFound.en,
    ...oss.en,
    ...ossInfo.en,
    ...ossResult.en,
    ...ossVote.en,
    ...payment.en,
    ...personalAccounts.en,
    ...polls.en,
    ...privilegeClub.en,
    ...profile.en,
    ...register.en,
    ...requestConfirmation.en,
    ...requests.en,
    ...services.en,
    ...shop.en,
    ...support.en,
    ...userCart.en,
    ...accessGuide.en,
    ...feedback.en,
    ...paymentInvoice.en,
  },
}